import { H1, LayoutBand, Separator } from '@fs/zion-ui'
import { PersonBandSkeleton } from '@fs/zion-person-band'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ResearchHelpTabsSkeleton from './components/ResearchHelpTabsSkeleton'

export default function ResearchHelpPageSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <>
      <PersonBandSkeleton maxWidth="lg" marginX="xxs" hasBackButton />

      <Separator size="sm" />

      <LayoutBand maxWidth="lg">
        <H1 size="H5">{t('tree-person.research-help.label')}</H1>
        <Separator size="sm" />
        <ResearchHelpTabsSkeleton />
      </LayoutBand>
    </>
  )
}
